// extracted by mini-css-extract-plugin
export default {"roleBox":"User_roleBox__nO1PW","filter-selected":"User_filter-selected__Sxa2y","filter-not-selected":"User_filter-not-selected__N+mz0"};